/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ severity: NonNullable<unknown>, message: NonNullable<unknown> }} Import_Issue_LabelInputs */

const cs_import_issue_label = /** @type {(inputs: Import_Issue_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.severity}: ${i?.message}`)
};

const en_import_issue_label = /** @type {(inputs: Import_Issue_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.severity}: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "{severity}: {message}" |
*
* @param {Import_Issue_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_issue_label = /** @type {((inputs: Import_Issue_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Issue_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_issue_label(inputs)
	return cs_import_issue_label(inputs)
});